import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'

import { Route } from 'react-router-dom'

import Login from '../Login/';
import SignUp from '../SignUp/';

import MessagingScreen from '../MessagingScreen/';
import UserProfile from '../UserProfile/';
import EditProfile from '../EditProfile/';

import DialogComponent from '../DialogComponent/';
import AddContactPage from '../AddContactPage/';
import Conversations from '../Conversations/';

import JitsuCamponent from '../JitsuCamponent/';
import Settings from '../Settings/';
import JitsuLoader from '../JitsuLoader/';

import { HashRouter } from 'react-router-dom'
import firebase from '../../firebase'

import { loginWithAccessToken } from './actions'

class App extends Component {
  constructor() {
    super();

    this.state = {
      title: "Home",
      incoming: "/conversations",
      loading: true,
    }

  }

  componentDidMount() {

    if (window.location.hash != '#/login') {

      this.setState({
        incoming: window.location.hash
      }, () => {
        this.initAuthCheck()

      })

    } else {

      this.initAuthCheck()

    }

  }

  initAuthCheck() {

    var {locationUtil} = this.props;

    var {params} = locationUtil

    if (params.accessToken) {

      this.props.loginWithAccessToken(params.accessToken)

        .then((authUser) => {

          if (authUser.user.uid) {

            this.setState({

              authUser: authUser.user,
              loading: false

            })

            window.location.hash = this.state.incoming

          }

        })

    } else {

      this.checkFireLoginStatus()

    }

  }

  checkFireLoginStatus() {

    firebase.auth().onAuthStateChanged((user) => {

      if (user) {

        var email = user.email;
        var uid = user.uid;
        var authUser = {
          email,
          uid
        }

        window.location.hash = this.state.incoming

        this.setState({
          authUser,
          loading: false
        })

      } else {

        this.setState({

          loading: false
        })

        if (this.state.incoming == "/conversations" || this.state.incoming == '#/') {

          window.location.hash = "/login"

        } else {

          window.location.hash = this.state.incoming

        }

      }

    });

  }

  render() {

    var {history} = this.props
    var {authUser} = this.state

    return authUser ?
      <HashRouter history={ history } basename='/'>
        <div className="h-100">
          <Route exact path="/" component={ Conversations } />
          <Route exact path="/logout" component={ Login } />
          <Route exact path="/login" component={ Login } />
          <Route exact path="/sign-up" component={ SignUp } />
          <Route exact path="/messaging" component={ MessagingScreen } />
          <Route exact path="/user-profile" component={ UserProfile } />
          <Route exact path="/conversations" component={ Conversations } />
          <Route exact path="/edit-profile" component={ EditProfile } />
          <Route exact path="/add-contact" component={ AddContactPage } />
          <Route exact path="/settings" component={ Settings } />
          <Route exact path="/join-jistu-chat" component={ SignUp } />
          <Route exact path="/jitsu-camponent" component={ JitsuCamponent } />
          <DialogComponent/>
        </div>
      </HashRouter>
      :
      <HashRouter history={ history } basename='/'>
        <div className="h-100">
          <Route exact path="/" component={ JitsuLoader } />
          <Route exact path="/messaging" component={ JitsuLoader } />
          <Route exact path="/login" component={ Login } />
          <Route exact path="/sign-up" component={ SignUp } />
          <Route exact path="/join-jistu-chat" component={ SignUp } />
          <Route exact path="/user-profile" component={ UserProfile } />
          <DialogComponent/>
        </div>
      </HashRouter>


  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  locationUtil: state.locationUtil
})



export default connect(mapStateToProps, {
  loginWithAccessToken
})(App)


// WEBPACK FOOTER //
// ./src/Components/App/index.js